import * as React from 'react';
import { Typography, Tabs, Box, Button, Divider, Stack, Grid, Tab } from '@mui/material';
import { connect } from "react-redux";
import ChangePassword from '../LoginPages/ChangePassword';
import GavelIcon from '@mui/icons-material/Gavel';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import EditIcon from '@mui/icons-material/Edit';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EditProfile from './EditProfile';
import ViewWallet from './ViewWallet';
import Terms from '../StaticPages/Terms';
import { motion } from 'framer-motion';
import {
  marketingColors,
  sectionTitleSx,
  marketingFonts,
  marketingTabsSx,
} from '../../app/components/tickitMarketingTheme';
import { MarketingPage, MarketingCard } from '../../app/components/marketing';

export const Profile = () => {
  const [tab, setTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  const tabOptions = [
    {
      id: 0,
      icon: <EditIcon />,
      label: "Edit Profile",
      component: <EditProfile />,
      description: "Update your personal information",
    },
    {
      id: 1,
      icon: <EnhancedEncryptionIcon />,
      label: "Change Password",
      component: <ChangePassword embedded />,
      description: "Secure your account",
    },
    {
      id: 2,
      icon: <AccountBalanceWalletIcon />,
      label: "Wallet",
      component: <ViewWallet />,
      description: "Manage your digital wallet",
    },
    {
      id: 3,
      icon: <GavelIcon />,
      label: "Terms & Conditions",
      component: <Terms embedded />,
      description: "Read our terms and policies",
    },
  ];

  return (
    <MarketingPage maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h2" sx={{ ...sectionTitleSx, fontSize: { xs: '1.85rem', md: '2.25rem' }, mb: 1 }}>
            Profile
          </Typography>
          <Typography
            sx={{
              color: marketingColors.gray600,
              fontFamily: marketingFonts.body,
              maxWidth: '560px',
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Manage your account settings and preferences
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={3} sx={{ display: { xs: 'none', md: 'block' } }}>
            <MarketingCard sx={{ position: 'sticky', top: 100, p: 2 }}>
              <Stack spacing={1}>
                {tabOptions.map((option) => (
                  <Button
                    key={option.id}
                    onClick={() => setTab(option.id)}
                    startIcon={option.icon}
                    sx={{
                      justifyContent: 'flex-start',
                      p: 2,
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontFamily: marketingFonts.display,
                      fontWeight: 700,
                      color: tab === option.id ? marketingColors.p700 : marketingColors.gray600,
                      backgroundColor: tab === option.id ? marketingColors.p100 : 'transparent',
                      '&:hover': { backgroundColor: marketingColors.p100, color: marketingColors.p700 },
                    }}
                  >
                    {option.label}
                  </Button>
                ))}
              </Stack>
            </MarketingCard>
          </Grid>

          <Grid item xs={12} md={9}>
            <Box sx={{ display: { xs: 'block', md: 'none' }, mb: 2 }}>
              <MarketingCard sx={{ p: 1 }}>
                <Tabs
                  value={tab}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  sx={marketingTabsSx}
                >
                  {tabOptions.map((option) => (
                    <Tab key={option.id} icon={option.icon} label={option.label} sx={{ fontSize: '0.8rem', minHeight: 72 }} />
                  ))}
                </Tabs>
              </MarketingCard>
            </Box>

            <MarketingCard sx={{ p: { xs: 2.5, md: 4 }, minHeight: '400px' }}>
              <Box sx={{ mb: 3 }}>
                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>
                  {tabOptions[tab].icon}
                  <Typography
                    variant="h4"
                    sx={{
                      color: marketingColors.gray900,
                      fontFamily: marketingFonts.display,
                      fontWeight: 800,
                      fontSize: { xs: '1.25rem', md: '1.5rem' },
                    }}
                  >
                    {tabOptions[tab].label}
                  </Typography>
                </Stack>
                <Typography sx={{ color: marketingColors.gray600, fontFamily: marketingFonts.body }}>
                  {tabOptions[tab].description}
                </Typography>
                <Divider sx={{ mt: 2, borderColor: marketingColors.gray200 }} />
              </Box>

              <motion.div
                key={tab}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
              >
                {tabOptions[tab].component}
              </motion.div>
            </MarketingCard>
          </Grid>
        </Grid>
      </motion.div>
    </MarketingPage>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
